/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { AiFillWarning } from 'react-icons/ai'

import MainLayout from 'components/layouts/main'

import { toast, ToastContainer } from 'react-toastify'
import Chip from 'components/commons/chip'
import { getLastUpdatedSchedulerList } from 'services/features/scheduler-check'
import moment from 'moment'

const OverviewPage = () => {
  const [lastUpdatedList, setLastUpdatedList] = useState<any>([])
  const [limit, setLimit] = useState<number>(10)

  useEffect(() => {
    getFields()
  }, [])

  const getFields = async () => {
    console.log('getFields')
    getLastUpdatedSchedulerList().then((list: any) => {
      setLastUpdatedList(list)
    })
    return
  }

  function copyToClipboard(name: string, id: string) {
    navigator.clipboard.writeText(id)
    toast(name + ' ID Copied', {
      position: 'bottom-center',
      hideProgressBar: true,
      theme: 'dark',
      autoClose: 1000,
    })
  }

  const displayStatusIcon = (doc: any) => {
    if (doc?.updated_at) {
      const timeAgo = moment(doc?.updated_at.toDate()).fromNow()
      if (timeAgo.includes('hour ago')) {
        return <AiFillWarning size={30} color={'yellow'} />
      } else if (timeAgo.includes('hours ago')) {
        return <AiFillWarning size={30} color={'red'} />
      } else if (timeAgo.includes('day')) {
        return <AiFillWarning size={30} color={'red'} />
      } else {
        return <AiFillWarning size={30} color={'green'} />
      }
    } else {
      return <AiFillWarning size={30} color={'red'} />
    }
  }

  return (
    <React.Fragment>
      <MainLayout style={{ backgroundColor: '#FFFFFF' }}>
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-2xl text-center pb-4 pt-8 md:text-left lg:text-left px-6'>
            Overview Page
          </h1>

          <table className='w-full flex flex-row flex-nowrap overflow-hidden mb-4'>
            <thead className='hidden border-b md:table-header-group lg:table-header-group'>
              <tr className='flex flex-col flex-nowrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0'>
                <th className='text-left font-bold'></th>
                <th className='text-left p-4 font-bold'>Scheduler</th>
                <th className='text-left p-4 font-bold'>Last Updated At</th>
                <th className='text-left p-4 font-bold'></th>
                <th className='text-left p-4 font-bold'></th>
              </tr>
            </thead>
            <tbody className='w-full'>
              {!lastUpdatedList && <p>Loading...</p>}

              {lastUpdatedList &&
                lastUpdatedList.map((doc: any, index: number) => (
                  <tr
                    key={index}
                    className='bg-white flex flex-col flex-nowrap rounded-lg sm:table-row sm:mb-4 md:rounded-none lg:rounded-none'
                  >
                    <td className='p-4 flex center'> </td>
                    <td className='p-4 sm:flex-1'>
                      <p className='text-left font-bold md:hidden lg:hidden py-2'>
                        Name & Collection ID
                      </p>
                      <div className='flex flex-col lg:items-center lg:flex-row lg:space-x-2'>
                        <div className='flex shrink-0 pr-4'>{displayStatusIcon(doc)}</div>
                        <div className='flex-1 truncate'>
                          <p style={{ maxWidth: 200 }}>{doc?.schedulerName}</p>
                          <div className='flex flex-row'>
                            <p className='text-sm' style={{ fontSize: 12 }}>
                              Start after: &quot;{doc?.startAfter}&quot;
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className='p-4 sm:flex-1'>
                      <p className='text-left font-bold md:hidden lg:hidden py-2'>
                        Last Updated At
                      </p>
                      <div className='flex flex-col lg:items-center lg:flex-row lg:space-x-2'>
                        <div className='flex-1 truncate'>
                          <p>
                            {doc?.updated_at // new Date(doc?.last_updated_at.toDate()).toDateString()
                              ? new Date(doc?.updated_at.toDate()).toLocaleTimeString('en-US', {
                                  // en-US can be set to 'default' to use user's browser settings
                                  month: 'short',
                                  day: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                })
                              : 'N/A'}
                          </p>
                          <p>
                            {doc?.updated_at // new Date(doc?.last_updated_at.toDate()).toDateString()
                              ? moment(doc?.updated_at.toDate()).fromNow()
                              : 'N/A'}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td className='p-3 sm:flex-1' style={{ maxWidth: 400, flexWrap: 'wrap' }}>
                      <p className='text-left font-bold md:hidden lg:hidden py-2'>Links</p>
                      {doc?.slug && (
                        <div className='truncate' style={{ flexWrap: 'wrap' }}>
                          <a
                            href={'https://opensea.io/collection/' + doc?.slug}
                            className='text-blue-500 underline underline-offset-2'
                            target='_blank'
                            rel='noreferrer'
                          >
                            {'https://opensea.io/collection/' + doc?.slug}
                          </a>
                        </div>
                      )}
                      {doc?.magic_eden_slug && (
                        <div className='truncate' style={{ flexWrap: 'wrap' }}>
                          <a
                            href={'https://magiceden.io/marketplace/' + doc?.magic_eden_slug}
                            className='text-blue-500 underline underline-offset-2'
                            target='_blank'
                            rel='noreferrer'
                          >
                            {'https://magiceden.io/marketplace/' + doc?.magic_eden_slug}
                          </a>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <ToastContainer limit={1} autoClose={3000} />
      </MainLayout>
    </React.Fragment>
  )
}

export default OverviewPage
